let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3xh1Y")).then(() => parcelRequire('4oGzS'));